import { Box, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';

const safeNum = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
};

export default function StackAdaptSpendStrip(props) {
    const {
        showCost,
        showRevenue,
        title,
        cost,
        revenue,
        tileSx
    } = props;

    if (!showCost && !showRevenue) return null;

    const safeCost = safeNum(cost);
    const safeRevenue = safeNum(revenue);
    const roi = safeCost > 0 ? safeRevenue / safeCost : 0;

    return (
        <Box py={1} mb={0} display="flex">
            <Box
                sx={{
                    display: { xs: 'flex' },
                    flex: 1,
                    gap: { xs: 2, sm: 0.5 },
                    flexDirection: { xs: 'column', sm: 'row' },
                    maxWidth: 760
                }}
            >
                {showCost ? (
                    <Box sx={tileSx}>
                        <Typography align="center" variant="subtitle2">{title} Expense</Typography>
                        <Typography align="center" variant="subtitle2">
                            <NumericFormat value={safeCost} displayType="text" prefix="$" decimalScale={2} thousandSeparator="," />
                        </Typography>
                    </Box>
                ) : null}
                {showRevenue ? (
                    <Box sx={tileSx}>
                        <Typography align="center" variant="subtitle2">{title} Revenue</Typography>
                        <Typography align="center" variant="subtitle2">
                            <NumericFormat value={safeRevenue} displayType="text" prefix="$" decimalScale={2} thousandSeparator="," />
                        </Typography>
                    </Box>
                ) : null}
                {showCost ? (
                    <Box sx={tileSx}>
                        <Typography align="center" variant="subtitle2">{title} ROI</Typography>
                        <Typography align="center" variant="subtitle2">
                            <NumericFormat value={roi} displayType="text" suffix="x" decimalScale={2} thousandSeparator="," />
                        </Typography>
                    </Box>
                ) : null}
            </Box>
        </Box>
    );
}
